<div class="flex flex-col w-full gap-1">
    @if (label) {
        <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>
    }

    <input
        #input
        #inputRef
        [type]="type"
        [id]="id"
        [placeholder]="placeholder"
        [disabled]="isReadOnly"
        [(ngModel)]="value"
        (blur)="adicionaMascara($event)"
        (focus)="focouNoInput($event)"
        (keypress)="insereDigitos($event)"
        (keydown.enter)="onEnterpress.emit(true)"
        autocomplete="off"
        pInputText
        class="bg-white h-8! border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg"
    />
</div>
